import styled, { css } from 'styled-components';

import { FontSize } from '../../theme/Typography';
import { getFontStyle, rem } from '../../utils';

export const cssTruncate = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const cssLineTruncate = (lines: number) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const cssBreakLine = css`
  white-space: pre-wrap;
  word-wrap: break-word;
`;

interface StyledTextProps {
  $size: FontSize;
  $color?: string;
  $maxWidth?: number;
  $truncate?: boolean | number;
  $fontWeight?: string;
  $fontFamily?: string;
  $fontStyle?: string;
  $fontWidth?: string;
  $block?: boolean;
  $textDecoration?: React.CSSProperties['textDecoration'];
}

export const StyledText = styled.span<StyledTextProps>(
  ({
    theme,
    $color,
    $size,
    $maxWidth,
    $truncate,
    $fontWeight,
    $fontStyle,
    $fontFamily,
    $fontWidth,
    $block,
    $textDecoration,
  }) => css`
    display: ${$block ? 'block' : 'inline'};
    ${$maxWidth && `max-width: ${rem($maxWidth)};`}
    color: ${$color ?? theme.Color.Neutrals.Dark};

    ${getFontStyle($size)}

    ${$fontFamily && `font-family: ${$fontFamily};`};
    ${$fontWeight && `font-weight: ${$fontWeight};`}
    ${$fontStyle && `font-style: ${$fontStyle};`}
    ${$fontWidth && `font-stretch: ${$fontWidth};`}

    ${$truncate === true
      ? cssTruncate
      : typeof $truncate === 'number'
      ? cssLineTruncate($truncate)
      : cssBreakLine}

    ${$textDecoration && `text-decoration: ${$textDecoration};`};
  `
);
